import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: "da",
    fallbackLng: "en",
    // debug: process.env.NODE_ENV === "production" ? false : true,

    // have a common namespace used around the full app
    ns: ["translation"],
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}.{{ns}}.json",
    },
  });

export default i18n;
